module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sofia Grant\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Sofia Grant has the heart of a homemaker, the curiosity of a cat, and the keen eye of a scout. She works from an urban aerie in Oakland, California.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/14KIQfu/tc-custom/9780062693457.jpg?1724855611164",
      "alt": "This image is the cover for the book Daisy Children"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Daisy Children\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Inspired by true events, in Sofia Grant’s powerfully moving new novel a young woman peels back the layers of her family’s history, discovering a tragedy in the past that explains so much of the present. This unforgettable story is one of hope, healing, and the discovery of truth.")]), _c('p', [_c('i', [_vm._v("Sometimes the untold stories of the past are the ones we need to hear...")])]), _c('p', [_vm._v("When Katie Garrett gets the unexpected news that she’s received an inheritance from the grandmother she hardly knew, it couldn’t have come at a better time. She flees Boston—and her increasingly estranged husband—and travels to rural Texas. ")]), _c('p', [_vm._v("There, she’s greeted by her distant cousin Scarlett. Friendly, flamboyant, eternally optimistic, Scarlett couldn’t be more different from sensible Katie. And as they begin the task of sorting through their grandmother’s possessions, they discover letters and photographs that uncover the hidden truths about their shared history, and the long-forgotten tragedy of the New London school explosion of 1937 that binds them.")]), _c('p', [_vm._v(". ")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollinsPublishers\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0